export default class MediacopyrightComponent {
    constructor() {
        MediacopyrightComponent.onClick()
    }

    static onClick() {
        const mediacopyright = $('.mediacopyright')
        if (mediacopyright.length > 0) {
            mediacopyright.on('click', (e) => {
                e.preventDefault()
                mediacopyright.toggleClass('active')
            })
        }
    }
}
